export default __webpack_public_path__ + "static/media/planet.d6ab77a9.png";